export default __webpack_public_path__ + "static/media/our-story-hero.b012bb9a.png";